import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// ── Ödeme & güven logoları (sepet10 footer'ından taşındı) ──
import footerImageCreditCartIyzico          from '../../Assets/Images/footer/credit-cart/iyzico_ile_ode_colored.svg';
import footerImageCreditCartBonusCard       from '../../Assets/Images/footer/credit-cart/bonus-card.svg';
import footerImageCreditCartMaximum         from '../../Assets/Images/footer/credit-cart/maximum.svg';
import footerImageCreditCartWorld           from '../../Assets/Images/footer/credit-cart/world.svg';
import footerImageCreditCartZiraat          from '../../Assets/Images/footer/credit-cart/ziraat.svg';
import footerImageCreditCartQnb             from '../../Assets/Images/footer/credit-cart/qnb.png';
import footerImageCreditCartAxess           from '../../Assets/Images/footer/credit-cart/axess.svg';
import footerImageCreditCartHsbc            from '../../Assets/Images/footer/credit-cart/hsbc.svg';
import footerImageCreditCartParaf           from '../../Assets/Images/footer/credit-cart/paraf.svg';
import footerImageCreditCartVisa            from '../../Assets/Images/footer/credit-cart/visa.svg';
import footerImageCreditCartMasterCard      from '../../Assets/Images/footer/credit-cart/master-card.svg';
import footerImageCreditCartAmericanExpress from '../../Assets/Images/footer/credit-cart/american-express.svg';
import footerImageCreditCartTroy            from '../../Assets/Images/footer/credit-cart/troy.svg';

// Renk paleti — tek yerden yönetilir
const R = {
  primary: '#013682',
  primaryHov: '#014aad',
  primaryLt: '#eff6fc',
  border: '#edebe9',
  bg: '#faf9f8',
  dark: '#201f1e',
  muted: '#605e5c',
  text: '#323130',
};

// Header yüksekliği — Layout ve sayfalar bu sabiti kullanır (sticky top hesabı için)
// Masaüstü = HEADER_H, mobil = HEADER_H_MOBILE
// Mobilde logo boyutu sabit; header yüksekliği bilinçli olarak yüksek tutuldu →
// alignItems:center ile logo dikey ortalanır, üstte ve altta belirgin beyaz alan oluşur.
export const HEADER_H = 72;
export const HEADER_H_MOBILE = 72;

// Ürün listesi — yol sabittir, ad/açıklama t() ile çevrilir
const URUN_LISTESI = [
  { anahtarAd: 'public.layout.product.corvia.name', anahtarAcik: 'public.layout.product.corvia.desc', yol: '/product/saas/corvia', ikon: 'https://img.icons8.com/color/96/cloud.png' },
  { anahtarAd: 'public.layout.product.cloud-instance.name', anahtarAcik: 'public.layout.product.cloud-instance.desc', yol: '/product/infrastructure/cloud-instance', ikon: 'https://img.icons8.com/color/96/virtual-machine.png' },
  /*
  { anahtarAd: 'public.layout.product.tatalli-directory.name', anahtarAcik: 'public.layout.product.tatalli-directory.desc', yol: '/infrastructure/tatalli-directory', ikon: 'https://img.icons8.com/color/96/network.png' },
  { anahtarAd: 'public.layout.product.tatalli-iam.name', anahtarAcik: 'public.layout.product.tatalli-iam.desc', yol: '/infrastructure/tatalli-iam', ikon: 'https://img.icons8.com/color/96/security-checked.png' },
  { anahtarAd: 'public.layout.product.postgres.name', anahtarAcik: 'public.layout.product.postgres.desc', yol: '/infrastructure/postgres', ikon: 'https://img.icons8.com/color/96/postgreesql.png' },
  { anahtarAd: 'public.layout.product.artemis.name', anahtarAcik: 'public.layout.product.artemis.desc', yol: '/infrastructure/artemis-mq', ikon: 'https://img.icons8.com/color/96/message-bot.png' },
  { anahtarAd: 'public.layout.product.s3.name', anahtarAcik: 'public.layout.product.s3.desc', yol: '/infrastructure/s3-storage', ikon: 'https://img.icons8.com/color/96/cloud-storage.png' },*/
];

const DESTEKLENEN_DILLER = [
  { kod: 'en', bayrak: '🇬🇧', etiket: 'English' },
  { kod: 'tr', bayrak: '🇹🇷', etiket: 'Türkçe' },
];

const MOBIL_BP = 768;
const mobilMi = () => typeof window !== 'undefined' && window.innerWidth < MOBIL_BP;

/* ─────────────────────────────────────────
   DilSecici bileşeni
───────────────────────────────────────── */
export function DilSecici() {
  const { i18n } = useTranslation();
  const [acik, setAcik] = useState(false);
  const ref = useRef(null);

  const aktifDil = DESTEKLENEN_DILLER.find(d => d.kod === i18n.language) ?? DESTEKLENEN_DILLER[0];

  useEffect(() => {
    const disaTikla = e => { if (ref.current && !ref.current.contains(e.target)) setAcik(false); };
    document.addEventListener('mousedown', disaTikla);
    return () => document.removeEventListener('mousedown', disaTikla);
  }, []);

  const dilDegistir = kod => { i18n.changeLanguage(kod); setAcik(false); };

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <button
        onClick={() => setAcik(p => !p)}
        style={{
          display: 'flex', alignItems: 'center', gap: 6,
          background: 'transparent', border: '1px solid transparent',
          borderRadius: 4, padding: '6px 12px',
          fontSize: 13, cursor: 'pointer', color: R.text, fontWeight: 500,
        }}
      >
        {aktifDil.bayrak} {aktifDil.kod.toUpperCase()}
        <i className="fas fa-chevron-down" style={{ fontSize: 9, marginLeft: 4 }} />
      </button>

      {acik && (
        <div style={{
          position: 'absolute', right: 0, top: '110%', background: '#fff',
          border: `1px solid ${R.border}`, borderRadius: 4, minWidth: 130,
          zIndex: 1200, boxShadow: '0 8px 20px rgba(0,0,0,0.12)',
        }}>
          {DESTEKLENEN_DILLER.map(({ kod, bayrak, etiket }) => (
            <div key={kod} onClick={() => dilDegistir(kod)}
              style={{ padding: '10px 16px', cursor: 'pointer', fontSize: 13 }}
              className="pl-dil-secenegi"
            >
              {bayrak} {etiket}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

/* ─────────────────────────────────────────
   Ana layout iskeleti
   Global CSS buradan yönetilir — sayfalar
   bu class'ları doğrudan kullanabilir.
───────────────────────────────────────── */
export default function PublicLayout({ children, title }) {
  const { t } = useTranslation();
  const [megaAcik, setMegaAcik] = useState(false);
  const [mobMenu, setMobMenu] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [isMobil, setIsMobil] = useState(mobilMi);

  useEffect(() => {
    document.title = title ? `${title} — Tatalli Cloud` : 'Tatalli Cloud';

    const kaydirmaIzle = () => setScrolled(window.scrollY > 10);
    const ekranIzle = () => setIsMobil(mobilMi());

    // Mount anında bir kez senkronla — SSR/hydration sonrası isMobil
    // doğru değere otomatik gelsin (resize beklemeden).
    ekranIzle();

    window.addEventListener('scroll', kaydirmaIzle);
    window.addEventListener('resize', ekranIzle);
    return () => {
      window.removeEventListener('scroll', kaydirmaIzle);
      window.removeEventListener('resize', ekranIzle);
    };
  }, [title]);

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', flexDirection: 'column',
      fontFamily: "'Inter', 'Segoe UI', sans-serif",
      background: '#fff', color: R.text,
    }}>

      {/*
        ════════════════════════════════════════════════
        GLOBAL STİLLER
        Tüm sayfaların ortak kullandığı utility class'lar
        buradan yönetilir — sayfa dosyalarında tekrar
        tanımlanmaz. Böylece sayfa değişiminde görünüm
        tutarlı kalır.
        ════════════════════════════════════════════════
      */}
      <style>{`
        /* Reset — sadece box-sizing, margin/padding sıfırlama
           kaldırıldı çünkü sayfa içi stilleri eziyor */
        *, *::before, *::after { box-sizing: border-box; }

        /* ── CSS Değişkenleri ── */
        :root {
          --pl-primary:        ${R.primary};
          --pl-primary-hov:    ${R.primaryHov};
          --pl-primary-lt:     ${R.primaryLt};
          --pl-border:         ${R.border};
          --pl-bg:             ${R.bg};
          --pl-muted:          ${R.muted};
          --pl-text:           ${R.text};
          --pl-dark:           ${R.dark};
          --pl-header-h:       ${HEADER_H}px;
          --pl-header-h-mob:   ${HEADER_H_MOBILE}px;
          --pl-max-w:          1300px;
          --pl-pad-x:          24px;    /* masaüstü yatay padding */
          --pl-radius:         6px;
        }

        /* ── Konteyner ──
           Tüm sayfalar "pl-container" kullanır → tutarlı hizalama */
        .pl-container {
          width: 100%;
          max-width: var(--pl-max-w);
          margin: 0 auto;
          padding: 0 var(--pl-pad-x);
        }

        /* ── Tip ── */
        body {
          font-family: 'Inter', 'Segoe UI', system-ui, sans-serif;
          background: #fff;
          color: var(--pl-text);
          line-height: 1.6;
          margin: 0;
        }

        /* ── Butonlar ── */
        .pl-btn {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 10px 22px;
          border-radius: var(--pl-radius);
          font-weight: 600;
          font-size: 14px;
          text-decoration: none;
          border: none;
          cursor: pointer;
          transition: background 0.18s, box-shadow 0.18s, transform 0.15s;
          white-space: nowrap;
        }
        .pl-btn-primary {
          background: var(--pl-primary);
          color: #fff;
          box-shadow: 0 2px 6px rgba(0,120,212,0.22);
        }
        .pl-btn-primary:hover {
          background: var(--pl-primary-hov);
          box-shadow: 0 4px 12px rgba(0,120,212,0.32);
          transform: translateY(-1px);
        }
        .pl-btn-outline {
          background: #fff;
          color: var(--pl-primary);
          border: 1.5px solid var(--pl-primary);
        }
        .pl-btn-outline:hover {
          background: var(--pl-primary-lt);
        }
        .pl-btn-ghost {
          background: transparent;
          color: var(--pl-text);
          border: 1.5px solid var(--pl-border);
        }
        .pl-btn-ghost:hover { background: #f3f2f1; }

        /* ── Rozetler ── */
        .pl-badge {
          display: inline-flex; align-items: center;
          padding: 2px 8px; border-radius: 99px;
          font-size: 11px; font-weight: 600; line-height: 1.6;
        }
        .pl-badge-blue  { background: #dbeafe; color: #1d4ed8; }
        .pl-badge-green { background: #dcfce7; color: #15803d; }

        /* ── Nav linkleri ── */
        .pl-nav-link {
          text-decoration: none;
          color: var(--pl-text);
          font-size: 15px;
          font-weight: 500;
          transition: color 0.18s;
        }
        .pl-nav-link:hover { color: var(--pl-primary); }

        /* ── Mega-menü kart ── */
        .pl-mega-kart {
          display: flex; gap: 14px; padding: 14px; border-radius: 8px;
          transition: background 0.18s, transform 0.18s;
          text-decoration: none; color: var(--pl-text);
        }
        .pl-mega-kart:hover { background: #f3f2f1; transform: translateY(-2px); }

        /* ── Footer linkleri ── */
        .pl-footer-link {
          display: block; font-size: 14px; margin-bottom: 10px;
          color: #c8c6c4; text-decoration: none; transition: color 0.18s, padding-left 0.18s;
        }
        .pl-footer-link:hover { color: #fff; padding-left: 4px; }

        /* ── Dil seçeneği ── */
        .pl-dil-secenegi:hover { background: var(--pl-primary-lt); }

        /* ── Marka bloğu — mobil/masaüstü uyumu ── */
        .pl-brand-link {
          display: flex;
          align-items: center;
          gap: 10px;
          text-decoration: none;
          margin-right: 40px;
          flex-shrink: 0;
        }
        .pl-brand-logo { width: 130px; height: auto; display: block; }
        .pl-brand-cloud {
          font-size: 24px; font-weight: 700;
          color: var(--pl-text);
          line-height: 1;
        }
        .pl-brand-row { display: flex; align-items: center; gap: 8px; }

        /* ── HEADER — yükseklik CSS ile zorlanır, JS state'ine bağlı değil ──
           !important kullanıldı çünkü eski versiyonlarda inline style ile
           verilen height tarayıcı cache'inde sıkışmış olabilir. */
        .pl-header {
          position: sticky;
          top: 0;
          z-index: 1000;
          background: #fff;
          border-bottom: 1px solid var(--pl-border);
          height: ${HEADER_H}px !important;
          min-height: ${HEADER_H}px !important;
          transition: box-shadow 0.18s;
        }
        .pl-header-inner {
          display: flex;
          align-items: center;
          height: 100%;
        }

        /* ── Görünürlük yardımcıları ── */
        .pl-gizle-mob  { display: flex; align-items: center; }
        .pl-goster-mob { display: none; }

        /* ────────────────────────────────────
           DUYARLI TASARIM
           Kırılma noktaları tek yerde tanımlı
        ──────────────────────────────────── */
        @media (max-width: 992px) {
          .pl-gizle-mob  { display: none !important; }
          .pl-goster-mob { display: flex; }
          .pl-brand-link { margin-right: 0; }
        }

        @media (max-width: 768px) {
          :root {
            --pl-pad-x: 16px;
            --pl-header-h: ${HEADER_H_MOBILE}px;
          }
          /* MOBİL HEADER YÜKSEKLİĞİ — !important ile zorlanır.
             Logo aynı boyutta kalır; ekstra yükseklik üst ve alta beyaz alan olarak dağılır. */
          .pl-header {
            height: ${HEADER_H_MOBILE}px !important;
            min-height: ${HEADER_H_MOBILE}px !important;
          }
          .pl-brand-logo  { width: 100px; }
          .pl-brand-cloud { font-size: 20px; }
        }

        @media (max-width: 480px) {
          :root { --pl-pad-x: 14px; }
          .pl-brand-row  { gap: 6px; }
          .pl-brand-logo { width: 88px; }
          .pl-brand-cloud{ font-size: 18px; }
        }

        @media (max-width: 360px) {
          .pl-brand-logo { width: 78px; }
          .pl-brand-cloud{ font-size: 16px; }
        }
      `}</style>

      {/* ════════════ HEADER ════════════ */}
      {/* Yükseklik CSS .pl-header class'ından geliyor (mobil için 156px !important).
          Burada JS state ile height set ETMİYORUZ — viewport değişimine
          tarayıcının kendi media query motoru anında tepki versin diye. */}
      <header className="pl-header" style={{
        boxShadow: scrolled
          ? '0 6px 16px rgba(0,0,0,0.08)'
          : '0 2px 8px rgba(0,0,0,0.04)',
      }}>
        <div className="pl-container pl-header-inner">

          {/* Marka */}
          <Link to="/" title="Tatalli Cloud" className="pl-brand-link m-0 pt-2">
            <div className="pl-brand-row">
              <img src="/logo-color712x186-removebg.png" alt="Tatalli" className="pl-brand-logo" />
            </div>
          </Link>
          <React.Fragment className="pl-brand-link">
            <div className="pl-brand-row">
              <span className="pl-brand-cloud">&nbsp; | &nbsp; </span>
            </div>
          </React.Fragment>
          <Link to="/" title="Tatalli Cloud" className="pl-brand-link pt-1">
            <div className="pl-brand-row">
              <span className="pl-brand-cloud">Cloud</span>
            </div>
          </Link>          

          {/* Masaüstü navigasyon */}
          <nav className="pl-gizle-mob" style={{ gap: 28 }}>

            {/* Ürünler mega-menüsü */}
            <div
              onMouseEnter={() => setMegaAcik(true)}
              onMouseLeave={() => setMegaAcik(false)}
              style={{ position: 'relative', height: HEADER_H, display: 'flex', alignItems: 'center' }}
            >
              <button style={{
                border: 'none', background: 'none',
                fontSize: 15, fontWeight: 600,
                cursor: 'pointer', color: R.text,
              }}>
                {t('public.layout.nav.products')}
                <i className="fas fa-chevron-down" style={{ fontSize: 10, marginLeft: 4 }} />
              </button>

              {megaAcik && (
                <div style={{
                  position: 'absolute', top: '100%', left: -100, width: 700,
                  background: '#fff', border: `1px solid ${R.border}`, borderRadius: 8,
                  boxShadow: '0 20px 40px rgba(0,0,0,0.12)', padding: 20,
                  display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, zIndex: 1100,
                }}>
                  {URUN_LISTESI.map((u, i) => (
                    <Link key={i} to={u.yol} className="pl-mega-kart">
                      <img src={u.ikon} alt="" style={{ width: 40, height: 40 }} />
                      <div>
                        <div style={{ fontWeight: 600, fontSize: 14 }}>{t(u.anahtarAd)}</div>
                        <div style={{ fontSize: 12, color: R.muted, marginTop: 2 }}>{t(u.anahtarAcik)}</div>
                      </div>
                    </Link>
                  ))}
                </div>
              )}
            </div>

            <Link to="/docs" className="pl-nav-link d-none">{t('public.layout.nav.docs')}</Link>
            <Link to="/calculator" className="pl-nav-link  d-none">{t('public.layout.nav.pricing')}</Link>
            <Link to="/contact" className="pl-nav-link  d-none">{t('public.layout.nav.contact')}</Link>
          </nav>

          {/* Masaüstü eylem butonları */}
          <div className="pl-gizle-mob" style={{ marginLeft: 'auto', gap: 15 }}>
            <DilSecici />
            <Link to="/portal/login" style={{ textDecoration: 'none', color: R.text, fontSize: 14, fontWeight: 600 }}>
              {t('public.layout.nav.signin')}
            </Link>
            <Link to="/pricing/purchase-options" className="pl-btn pl-btn-primary">{t('public.layout.nav.start-free')}</Link>
          </div>

          {/* Mobil — dil seçici + hamburger */}
          <div className="pl-goster-mob" style={{ marginLeft: 'auto', alignItems: 'center', gap: 6 }}>
            <DilSecici />
            <button
              onClick={() => setMobMenu(p => !p)}
              aria-label="Menu"
              style={{
                background: 'none', border: 'none',
                fontSize: 22, cursor: 'pointer',
                padding: '8px 10px',
                color: R.text,
                display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                lineHeight: 1,
              }}
            >
              <i className={`fas fa-${mobMenu ? 'times' : 'bars'}`} />
            </button>
          </div>
        </div>

        {/* Mobil menü — tam ekran panel
            top değeri için doğrudan HEADER_H_MOBILE kullanıldı; mobil menü
            zaten yalnızca mobilde açılıyor → isMobil state'ine bağımlı olmasına gerek yok. */}
        {mobMenu && (
          <div style={{
            position: 'fixed',
            top: HEADER_H_MOBILE,
            left: 0, right: 0, bottom: 0,
            background: '#fff', overflowY: 'auto', zIndex: 999,
            borderTop: `1px solid ${R.border}`,
          }}>
            {/* CTA butonları */}
            <div style={{ padding: '16px 20px', display: 'grid', gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)', gap: 10, borderBottom: `1px solid ${R.border}` }}>
              <Link to="/portal/login" onClick={() => setMobMenu(false)}
                style={{
                  flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center',
                  textAlign: 'center', padding: '10px',
                  border: `1px solid ${R.border}`, borderRadius: 4,
                  textDecoration: 'none', color: R.text, fontSize: 14, fontWeight: 600,
                }}
              >
                {t('public.layout.nav.signin')}
              </Link>
              <Link to="/pricing/purchase-options" onClick={() => setMobMenu(false)}
                className="pl-btn pl-btn-primary"
                style={{ flex: 1, justifyContent: 'center', textAlign: 'center', whiteSpace: 'normal' }}
              >
                {t('public.layout.nav.start-free')}
              </Link>
            </div>

            {/* Ürünler */}
            <div style={{ padding: '16px 20px 8px', fontSize: 11, fontWeight: 700, color: R.muted, letterSpacing: '0.08em', textTransform: 'uppercase' }}>
              {t('public.layout.nav.products')}
            </div>
            {URUN_LISTESI.map((u, i) => (
              <Link key={i} to={u.yol} onClick={() => setMobMenu(false)}
                style={{
                  display: 'flex', alignItems: 'center', gap: 14,
                  padding: '12px 20px', borderBottom: `1px solid ${R.border}`,
                  textDecoration: 'none', color: R.text,
                }}
              >
                <img src={u.ikon} alt="" style={{ width: 36, height: 36, flexShrink: 0 }} />
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 600, fontSize: 14 }}>{t(u.anahtarAd)}</div>
                  <div style={{ fontSize: 12, color: R.muted, marginTop: 2 }}>{t(u.anahtarAcik)}</div>
                </div>
                <i className="fas fa-chevron-right" style={{ fontSize: 11, color: R.muted }} />
              </Link>
            ))}

            {/* Ana nav linkleri */}
            {[
              /*{ to: '/docs', label: t('public.layout.nav.docs') },*/
              /*{ to: '/calculator', label: t('public.layout.nav.pricing') },*/
              { to: '/contact', label: t('public.layout.nav.contact') },
            ].map(({ to, label }) => (
              <Link key={to} to={to} onClick={() => setMobMenu(false)}
                style={{
                  display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                  padding: '0 20px', height: 52,
                  borderBottom: `1px solid ${R.border}`,
                  textDecoration: 'none', color: R.text,
                  fontSize: 15, fontWeight: 500,
                }}
              >
                {label}
                <i className="fas fa-chevron-right" style={{ fontSize: 11, color: R.muted }} />
              </Link>
            ))}
          </div>
        )}
      </header>

      {/* Sayfa içeriği */}
      <main style={{ flex: 1 }}>{children}</main>

      {/* ════════════ FOOTER ════════════ */}
      <footer style={{ background: '#1f1f1f', color: '#fff', padding: '70px 0 40px' }}>
        <div className="pl-container">
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
            gap: 40, marginBottom: 60,
          }}>
            {/* Marka sütunu */}
            <div style={{ gridColumn: 'span 2' }}>
              <div style={{ fontWeight: 700, fontSize: 22, marginBottom: 15 }}>Tatalli Cloud</div>
              <p style={{ fontSize: 14, color: '#c8c6c4', lineHeight: 1.6, maxWidth: 320, margin: 0 }}>
                {t('public.layout.footer.tagline')}
              </p>
              <div style={{ marginTop: 25, fontSize: 20, display: 'flex', gap: 20 }}>
                <a href="#" style={{ color: '#fff' }}><i className="fab fa-github d-none" /></a>
                <a href="https://www.linkedin.com/company/tatalli" target="_blank" style={{ color: '#fff' }}><i className="fab fa-linkedin" /></a>
                <a href="#" style={{ color: '#fff' }}><i className="fab fa-twitter d-none" /></a>
              </div>
            </div>

            {/* Ürünler */}
            <div>
              <div style={{ fontWeight: 600, marginBottom: 20, fontSize: 16 }}>{t('public.layout.footer.products')}</div>
              <Link className="pl-footer-link" to="/product/saas/corvia">{t('public.layout.product.corvia.name')}</Link>
              <Link className="pl-footer-link" to="/product/infrastructure/cloud-instance">{t('public.layout.product.cloud-instance.name')}</Link>
              <Link className="pl-footer-link d-none" to="/infrastructure/postgres">{t('public.layout.product.postgres.name')}</Link>
              <Link className="pl-footer-link d-none" to="/infrastructure/artemis-mq">{t('public.layout.product.artemis.name')}</Link>
              <Link className="pl-footer-link d-none" to="/infrastructure/s3-storage">{t('public.layout.product.s3.name')}</Link>
            </div>

            {/* Kaynaklar */}
            <div>
              <div style={{ fontWeight: 600, marginBottom: 20, fontSize: 16 }}>{t('public.layout.footer.resources')}</div>
              <Link className="pl-footer-link d-none" to="/docs">{t('public.layout.footer.docs')}</Link>
              <Link className="pl-footer-link d-none" to="/docs/api">{t('public.layout.footer.api-ref')}</Link>
              <Link className="pl-footer-link" to="/status">{t('public.layout.footer.status')}</Link>
              <Link className="pl-footer-link d-none" to="/support">{t('public.layout.footer.support')}</Link>
            </div>

            {/* Şirket */}
            <div>
              <div style={{ fontWeight: 600, marginBottom: 20, fontSize: 16 }}>{t('public.layout.footer.company')}</div>
              <Link className="pl-footer-link" to="/about">{t('public.layout.footer.about')}</Link>
              <Link className="pl-footer-link" to="/contact">{t('public.layout.nav.contact')}</Link>
              <Link className="pl-footer-link d-none" to="/privacy">{t('public.layout.footer.privacy')}</Link>
              <Link className="pl-footer-link d-none" to="/terms">{t('public.layout.footer.terms')}</Link>
              <Link className="pl-footer-link" to="/protection-of-personal-data">{t('public.layout.footer.protection-of-personal-data')}</Link>
              <Link className="pl-footer-link" to="/agreements">{t('public.layout.footer.agreements')}</Link>
            </div>
          </div>

          {/* Alt çubuk */}
          <div style={{
            borderTop: '1px solid #333', paddingTop: 30,
            display: 'flex', flexDirection: 'column', gap: 20,
          }}>
            {/* ── Ödeme logoları ── */}
            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 10 }}>
              {[
                { src: footerImageCreditCartIyzico,          alt: 'iyzico'           },
                { src: footerImageCreditCartBonusCard,       alt: 'Bonus Card'       },
                { src: footerImageCreditCartMaximum,         alt: 'Maximum'          },
                { src: footerImageCreditCartWorld,           alt: 'World'            },
                { src: footerImageCreditCartZiraat,          alt: 'Ziraat'           },
                { src: footerImageCreditCartQnb,             alt: 'QNB'              },
                { src: footerImageCreditCartAxess,           alt: 'Axess'            },
                { src: footerImageCreditCartHsbc,            alt: 'HSBC'             },
                { src: footerImageCreditCartParaf,           alt: 'Paraf'            },
                { src: footerImageCreditCartVisa,            alt: 'Visa'             },
                { src: footerImageCreditCartMasterCard,      alt: 'MasterCard'       },
                { src: footerImageCreditCartAmericanExpress, alt: 'American Express' },
                { src: footerImageCreditCartTroy,            alt: 'Troy'             },
              ].map(({ src, alt }) => (
                <img
                  key={alt}
                  src={src}
                  alt={alt}
                  style={{
                    height: 16,
                    objectFit: 'contain',
                    /* Koyu footer arka planı için beyaza çevir; hover'da orijinal renk */
                    filter: 'brightness(0) invert(1)',
                    opacity: 0.45,
                    transition: 'opacity 0.25s, filter 0.25s',
                  }}
                  onMouseEnter={e => {
                    e.currentTarget.style.opacity = '1';
                    e.currentTarget.style.filter = 'none';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.opacity = '0.45';
                    e.currentTarget.style.filter = 'brightness(0) invert(1)';
                  }}
                />
              ))}
            </div>

            {/* ── Copyright satırı ── */}
            <div style={{
              fontSize: 13, color: '#a19f9d',
              display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 15,
            }}>
              <div>© {new Date().getFullYear()} {t('public.layout.footer.copyright.company-name')} — {t('public.layout.footer.copyright.all-rights-reserved')}</div>
              <div style={{ display: 'flex', gap: 20 }}>
                <span>{t('public.layout.footer.region')}</span>
                <span>{t('public.layout.footer.status-online')}: <span style={{ color: '#107c41' }}>● {t('public.layout.footer.online')}</span></span>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}